<app-modal-container
  [title]="'Bulk request'"
  [bigSize]="true"
  [titleDirection]="'start'"
  [buttons]="{close: true}"
  [formGroup]="companiesWrapperFormGroup"
  (closeButtonClicked)="closeEmitter.emit(isThereAnyChangeToRecipients)">
  <div
    *ngVar="companiesWrapperFormGroup.value as wrapper"
    class="centered-column-container column-gap-1 items-stretch">
    <div class="centered-column-container column-gap-1 bg-black-3 br-0p5 padding-1">
      <div class="space-between-horizontal-centered width-100pcnt">
        <app-checkbox
          data-qa="kpi-bulk-request-is-custom-text-enabled"
          formControlName="isCustomTextEnabled"
          class="font-4">
          Add custom text
        </app-checkbox>
        <div class="centered-row-container row-gap-0p5">
          @if (wrapper.isCustomTextEnabled) {
            <app-input
              data-qa="kpi-modal-bulk-kpi-request-test-email"
              formControlName="testEmail"
              [isShrinked]="true"
              [placeholder]="'Test email'"
            />
            <app-button
              [attr.data-qa]="'kpi-modal-bulk-kpi-request-send-email-button' "
              [size]="'xsmall'"
              [type]="'accent'"
              [bordersSquaredShape]="'full-small-button'"
              [disabled]="companiesWrapperFormGroup.controls.testEmail.invalid"
              (buttonClick)="sendTestEmail()">
              Send
            </app-button>
          }
        </div>
      </div>
      @if (wrapper.isCustomTextEnabled) {
        <app-input
          data-qa="kpi-bulk-request-custom-text"
          class="width-100pcnt textarea-height-6p125"
          formControlName="customText"
          placeholder="Enter the email body"
          [autofocus]="true"
          [inputClass]="'!max-h-[6.125rem]'"
          [textArea]="true"
        />
      }
    </div>
    <div
      data-qa="kpi-modal-bulk-kpi-request-div"
      class="centered-column-container column-gap-1">
      <div *ngIf="companiesWrapperFormGroup" class="table-fms max-h-[50rem] w-[50rem]">
        <table>
          <thead>
          <tr>
            <th class="fix-w-2"></th>
            <th class="fix-w-3p5">
              <div class="centered-row-container">
                Link
              </div>
            </th>
            <th class="fix-w-13p75">Company</th>
            <th class="fix-w-13p75">Recipients</th>
            <th class="fix-w-5p5">Last request</th>
            <th class="fix-w-5p5">Last submission</th>
          </tr>
          </thead>
          <tbody formArrayName="companies">
          <ng-container
            *ngFor="let company of companiesWrapperFormGroup.controls.companies.controls; let i = index"
            [formGroupName]="i">
            <tr [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' +company.value.name">
              <td class="fix-w-2"
                  [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-toggle-visibility'"
                  (click)="company.controls.isCompanyMemberShown.patchValue(!company.value.isCompanyMemberShown)">
                <app-table-group-icon
                  *ngIf="company.value.members.length > 0"
                  [opened]="company.value.isCompanyMemberShown"/>
              </td>
              <td class="fix-w-3p5">
                <app-switcher
                  [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-is-msl-activated'"
                  class="small-switcher"
                  formControlName="isMslActivated"
                />
              </td>
              <td class="fix-w-13p75"
                  [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-name'">
                {{ company.value.name }}
              </td>
              <td class="fix-x-w-13p7w-13p75">
                <div class="space-between-horizontal-centered">
                  <div class="start-row-container row-gap-0p5">
                    <app-checkbox
                      [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-is-at-least-one-member-selected'"
                      formControlName="isAtLeastOneMemberSelected"
                      [minus]="company.value.isAtLeastOneMemberSelected && !company.value.isAllMembersSelected"
                      (checkBoxClicked)="updateCompanyMemberVisibility(company)"
                    />
                    <div
                      *ngVar="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-recipients' as id"
                      class="centered-row-container row-gap-0p15"
                      [attr.id]="id"
                      [attr.data-qa]="id"
                      [class.opacity0p64]="!company.getRawValue().isMslActivated || company.value.members.length === 0"
                      (mouseenter)="showRecipientsTooltip(company, id)"
                      (mouseleave)="show.recipientsTooltip = null"
                    >
                      @if (company.value.amountOfMembersSelected) {
                        <span
                          [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-selected-amount'"
                          class="bold500">{{ company.value.amountOfMembersSelected }}</span>
                        <span>of</span>
                        <span
                          [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-total-amount'">
                          {{ company.value.members.length }}
                        </span>
                        <span>recipients</span>
                      } @else {
                        <span
                          [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-no-recipients'">No recipients</span>
                      }
                    </div>
                  </div>
                  <div>
                    <app-button
                      [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-add-member-button'"
                      [size]="'xxsmall'"
                      [iconName]="'plus.svg'"
                      [showIcon]="'left'"
                      (buttonClick)="addMember(company)"
                    >
                      Recipient
                    </app-button>
                  </div>
                </div>
              </td>
              @if (company.value.latestNotifications) {
                <td class="fix-w-5p5">
                  <div
                    [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-request-sent-cell'"
                    class="black-10 flex flex-row items-start align-middle gap-1"
                  >
                    <app-all-icons
                      [iconNameAndStyling]="'paper-plane-empty.svg;icon-size-1; black-10'"
                    />
                    {{ DateService.convertLocalDateTimeToDaysDiff(company.value.latestNotifications.requestSent) }}
                  </div>
                </td>
                <td class="fix-w-5p5">
                  <div
                    *ngIf="company.value.latestNotifications.requestReceived"
                    [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-request-received-cell'"
                    class="black-10 flex flex-row items-start align-middle gap-1"
                  >
                    <app-all-icons
                      [iconNameAndStyling]="'thin-return-arrow.svg;icon-size-1; black-10'"
                    />
                    {{ DateService.convertLocalDateTimeToDaysDiff(company.value.latestNotifications.requestReceived) }}
                  </div>
                </td>
              } @else {
                <td class="fix-w-5p5"></td>
                <td class="fix-w-5p5"></td>
              }
            </tr>
            @if (company.value.isCompanyMemberShown) {
              <ng-container formArrayName="members">
                @for (member of company.getRawValue().members; track member.name) {
                  <tr
                    *ngVar="$index !== company.value.members.length - 1 ? 'br-unset' : '' as brClass"
                    [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-' + member.name + 'row'"
                    [formGroupName]="$index">
                    <td class="fix-w-2" [ngClass]="brClass"></td>
                    <td class="fix-w-3p5" [ngClass]="brClass"></td>
                    <td class="fix-w-13p75" [ngClass]="brClass"></td>
                    <td colspan="3" [ngClass]="brClass">
                      <div class="flex flex-row justify-start items-center gap-0.625 pl-0.9375">
                        <app-checkbox
                          [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-' + member.name + '-is-selected'"
                          formControlName="isSelected"
                        />
                        <div class="select-container">
                          <app-three-dots-menu
                            [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-' + member.name + '-three-dots'"
                            [matMenuTriggerFor]="menu"></app-three-dots-menu>
                          <mat-menu #menu="matMenu">
                            <ul class="list">
                              <app-drop-down-item
                                [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-' + member.name + '-edit'"
                                class="width-100pcnt"
                                [text]="'Edit'"
                                [iconNameAndStyling]="'edit.svg'"
                                (click)="editMember(member, company)">
                              </app-drop-down-item>
                              <app-drop-down-item
                                [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-' + member.name + '-delete'"
                                class="width-100pcnt"
                                [text]="'Delete'"
                                [iconNameAndStyling]="'delete.svg'"
                                (click)="deleteMember(member, company)">
                              </app-drop-down-item>
                            </ul>
                          </mat-menu>
                        </div>
                        <span
                          [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-' + member.name + '-name'"
                          class="width-7">{{ member.name }} {{ member.family }}</span>
                        <div class="width-1"></div>
                        <span
                          [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-' + company.value.name + '-' + member.name + '-mail'"
                          class="width-7">{{ member.mail }}</span>
                      </div>
                    </td>
                  </tr>
                }
              </ng-container>
            }
          </ng-container>
          </tbody>
        </table>
      </div>
      <app-button
        [attr.data-qa]="'kpi-modal-bulk-kpi-request-company-submit-button'"
        [size]="'small'"
        [disabled]="wrapper.selectedCompaniesAmount === 0"
        [type]="'accent'"
        (buttonClick)="showSendBulkRequestModal()">
        Send request to {{ wrapper.selectedCompaniesAmount }} of {{ wrapper.allCompaniesAmount }} companies
      </app-button>
    </div>
  </div>
</app-modal-container>

@if (teamModal.isModalShown) {
  <app-kpi-modal-company-member-crud
    [member]="teamModal.employee"
    [isDeleteEnabled]="teamModal.isDeleteOperation"
    [company]="teamModal.company"
    (closeEmitter)="closeEmployeeModal($event)">
  </app-kpi-modal-company-member-crud>
}

@if (show.recipientsTooltip) {
  <app-tooltip
    class="whitespace-pre-line"
    [coordinates]="show.recipientsTooltip.tooltipCoordinates"
    [title]="show.recipientsTooltip.tooltipText"
  />
}

@if (showSendBulkRequestModalWarning) {
  <app-modal-container
    [innerModal]="true"
    [buttons]="{apply: 'Send now', dismiss: 'Cancel'}"
    (applyButtonClicked)="sendBulkKpiRequest()"
    (dismissButtonClicked)="hideSendBulkRequestModal()"
  >
    <div class="flex flex-col items-center justify-center gap-[1.25rem] w-[25rem] h-[5.3125rem] py-[3.75rem]">
      <app-all-icons [iconNameAndStyling]="'paper-plane-empty.svg;icon-size-3p125;black-9'"/>
      <div class="flex flex-col items-center justify-center gap-[0.625rem]">
        <span class="font-2 black-12 bold600 line-height-120">Confirm sending request</span>
        <span *ngVar="companiesWrapperFormGroup.value.selectedCompaniesAmount as companiesAmount" class="font-3 line-height-120 black-9">
          Your request will be sent to {{ companiesAmount === 1 ? '1 company' : companiesAmount + ' companies' }}
        </span>
      </div>
    </div>
  </app-modal-container>
}
